export interface StatItem {
  label: string;
  value: string | number;
  icon: string;
  // number = % change vs previous period, string = plain note
  delta?: number | string;
  // true when a rise is bad (e.g. failed payments)
  invert?: boolean;
}

// One divided stat bar used on every page (4 or 5 cells)
const StatStrip = ({ items }: { items: StatItem[] }) => (
  <div className={`cx-st ${items.length === 4 ? "st4" : ""}`}>
    {items.map((s) => {
      const isNum = typeof s.delta === "number";
      const d = s.delta as number;
      const good = isNum && (d >= 0) !== !!s.invert;
      return (
        <div className="cx-st-c" key={s.label}>
          <div className="cx-st-h"><span>{s.label}</span><i className={s.icon}></i></div>
          <div className="cx-st-v">{typeof s.value === "number" ? s.value.toLocaleString("en-IN") : s.value}</div>
          <div className="cx-st-f">
            {isNum ? (
              <>
                <span className={`cx-st-d ${d === 0 ? "" : good ? "g" : "b"}`}>
                  <i className={d >= 0 ? "ri-arrow-right-up-line" : "ri-arrow-right-down-line"}></i>{Math.abs(d).toFixed(1)}%
                </span>
                <span>vs prev. period</span>
              </>
            ) : <span>{s.delta || ""}</span>}
          </div>
        </div>
      );
    })}
  </div>
);

export default StatStrip;
